import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from '../../../../../../projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdModalContent } from '../../../../../../projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from '../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../../projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import * as fromEnums from '../../../../../../projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';

import { VehicleType } from '../../business-entities/vehicle-list-view-model';
import { Preferences } from '../../business-entities/preferences-model';
import { Categories } from '../../business-entities/category-list-model';
import { CategoryService } from '../../business-services/category.service';
import { AddCategoryComponent } from './add-category/add-category.component';
import { EditCategoryComponent } from './edit-category/edit-category.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
})
export class CategoryComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  language: string;
  total$: Observable<number>;
  popupCloseResult = false;
  fileName = 'ExcelSheet.xlsx';
  SelectedVehical: any;
  confrimationTitle: string
  paginationSub: Subscription
  currentlagSub: Subscription
  currentDateTime: Promise<Date>;
  categoryList: Categories[];
  preferenceList: Preferences[];
  userRoleRightsDetails: UserRoleMenu;
  vehicleTypes: VehicleType[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  confrimationMessage: any;
  constructor(
    private categoryService: CategoryService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    private userService: UserDataService,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['CategoryName', 'CategoryDescription', 'Active'];
    this.pService.searchTerm = '';

  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  async getCategoryList() {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    let requestObj =
    {
      LANGUAGECODE: language
    }
    await this.categoryService.getCategoryList(requestObj).then((response) => {
      this.pService.dataSource = response;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.categoryList = this.categoryMapping(result);
      });
    })
    this.spinner.hide();
  }

  private categoryMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {

      for (let index = 0; index < manualList.length; index++) {
        const element = manualList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.categoryName = element.categoryName;
        single.categoryDescription = element.categoryDescription;
        single.createdBy = element.createdBy;
        single.createdDate = element.createdDate;
        single.updatedBy = element.updatedBy;
        single.updatedDate = element.updatedDate;
        single.isActive = element.isActive;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.Category);
    this.pService.dataSource = [];
    this.cd.detectChanges();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getCategoryList()
    });
    setInterval(() => {
      this.currentDateTime =  Promise.resolve(new Date())
    }, 1000);
  }

  onEdit(id: number) {
    this.categoryService.categoryId = id
    const modalref = this.modalService.open(EditCategoryComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  onAdd() {
    const modalref = this.modalService.open(AddCategoryComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  refresh() {
    this.getCategoryList();
  }

  onActiveOrInactive(id: any) {
    let modelHeadermsg = this.translate.instant("lblActivateDeactivate");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblActiveInactive"), this.translate.instant("lblCategory"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    let requestObj =
    {
      PreferenceId: id
    }
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.categoryService
          .activeInactiveCategory(requestObj)
          .then((res) => {
            if (res.responseCode == Constant.SuccessResponseCode) {
              let successmsg = this.translate.instant("lblCategoryStatus");
              this.toastr.success(successmsg);
              this.getCategoryList();
            }
            this.spinner.hide();
          },
            (err) => {
              this.spinner.hide();
            });
      }
    });
  }

  deleteCategory(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblCategory"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.categoryService.deleteCategory(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblCategoryDeleted");
            this.toastr.success(deletedmsg)
            this.getCategoryList();
          }
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  /**
* Method to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
}
